import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import ProductImageGallery from '../../components/ProductImageGallery';
import RelatedProducts from '../../components/RelatedProducts';
import { useCart } from '../../context/CartContext';

const LEDCurtainLight = () => {
    const navigate = useNavigate();
    const { addToCart } = useCart();
  const [activeTab, setActiveTab] = useState('overview');
  const [currentImage, setCurrentImage] = useState('');
  const [selectedColor, setSelectedColor] = useState('Warm (with hook)');
  const [selectedLength, setSelectedLength] = useState('3m x 3m');
  const [quantity, setQuantity] = useState(1);
  
  // 产品数据
  const product = {
    id: 'led-curtain-light',
    name: '300 LED USB Curtain Lights – Decorative Glow for Home & Events',
    category: 'lighting',
    price: "S$17.90",
    originalPrice: "S$29.99",
    image: '/images/shop-products/led-curtain-light/led-curtain-light-1.jpg',
    description: 'Waterproof LED curtain lights for outdoor and indoor decoration with 300 LED lights and 8 different modes',
    specs: {
      "LEDs": "300",
      "Length": "3m x 3m",
      "Waterproof": "IP44",
      "Modes": "8 Different",
      "Power": "USB"
    },
    features: [
      "300 LED Lights",
      "Waterproof IP44",
      "8 Light Modes",
      "Easy Installation"
    ],
    inStock: true,
    rating: 4.9,
    reviews: 523
  };
  
  // 颜色图片映射
  const colorImages = {
    'Warm (with hook)': '/images/shop-products/led-curtain-light/led-curtain-light-7.jpg'
  };
  
  // 更多图片
  const additionalImages = [
    colorImages['Warm (with hook)'],
    '/images/shop-products/led-curtain-light/led-curtain-light-2.jpg',
    '/images/shop-products/led-curtain-light/led-curtain-light-3.jpg',
    '/images/shop-products/led-curtain-light/led-curtain-light-4.jpg',
    '/images/shop-products/led-curtain-light/led-curtain-light-5.jpg',
    '/images/shop-products/led-curtain-light/led-curtain-light-6.jpg',
    '/images/shop-products/led-curtain-light/led-curtain-light-7.jpg'
  ];

  // 初始化当前图片
  useEffect(() => {
    setCurrentImage(colorImages[selectedColor]);
  }, [selectedColor]);

  // 添加到购物车
  const handleAddToCart = () => {
    const cartItem = {
      id: product.id,
      name: product.name,
      price: parseFloat(product.price.replace('S$', '')),
      image: product.image,
      quantity: quantity,
      selectedColor: selectedColor,
      selectedLength: selectedLength
    };
    addToCart(cartItem);
  };

  // 立即购买
  const handleBuyNow = () => {
    const cartItem = {
      id: product.id,
      name: product.name,
      price: parseFloat(product.price.replace('S$', '')),
      image: product.image,
      quantity: quantity,
      selectedColor: selectedColor,
      selectedLength: selectedLength
    };
    addToCart(cartItem);
    navigate('/cart');
  };

  // 相关产品
  const relatedProducts = [
    {
      id: 1,
      name: "Lava Lamp",
      price: 49.99,
      image: "/images/shop-products/lava-lamp/1b7d1a2ce01d8e066743c9207a532a41.jpeg"
    },
    {
      id: 2,
      name: "RGB Gaming Mousepad",
      price: 39.99,
      image: "https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=500&h=500&fit=crop"
    },
    {
      id: 3,
      name: "Wireless Keyboard",
      price: 299.99,
      image: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=500&h=500&fit=crop"
    },
    {
      id: 4,
      name: "Gaming Headset",
      price: 199.99,
      image: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500&h=500&fit=crop"
    }
  ];

  return (
    <div className="container mx-auto px-4 py-12 text-white">
      {/* 面包屑导航 */}
      <div className="text-sm text-gray-400 mb-6">
        <Link to="/" className="hover:text-white">Home</Link> / 
        <Link to="/shop" className="hover:text-white mx-2">Shop</Link> / 
        <Link to="/shop/lighting" className="hover:text-white mr-2">Lighting</Link> / 
        <span className="text-white">{product.name}</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* 左侧产品图片 */}
        <div>
          <ProductImageGallery
            images={additionalImages}
            currentImage={currentImage}
            onImageChange={setCurrentImage}
          />
        </div>
        
        {/* 右侧产品信息 */}
        <div>
          <h1 className="text-3xl font-bold mb-2">{product.name}</h1>
          
          {/* 评分 */}
          <div className="flex items-center mb-4">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={i < Math.floor(product.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
              ))}
            </div>
            <span className="ml-2 text-gray-400">({product.reviews} reviews)</span>
          </div>
          
          {/* 价格 */}
          <div className="mb-6">
            <span className="text-3xl font-bold">{product.price}</span>
            {product.originalPrice && (
              <span className="ml-3 text-gray-400 line-through">{product.originalPrice}</span>
            )}
            {product.originalPrice && (
              <span className="ml-3 bg-red-600 text-white px-2 py-1 rounded-md text-sm">
                Save S${(parseFloat(product.originalPrice.replace(/^S\$/, '')) - parseFloat(product.price.replace(/^S\$/, ''))).toFixed(2)}
              </span>
            )}
          </div>
          
          {/* 库存状态 */}
          <div className="mb-6">
            {product.inStock ? (
              <span className="text-green-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                In Stock
              </span>
            ) : (
              <span className="text-red-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                Out of Stock
              </span>
            )}
          </div>
          
          {/* 简短描述 */}
          <p className="text-gray-300 mb-6">{product.description}</p>
          
          {/* 选择颜色 */}
          <div className="mb-6">
            <h3 className="text-lg font-medium mb-3">Choose Color</h3>
            <div className="flex gap-3">
              {[
                { name: 'Warm (with hook)', image: '/images/shop-products/led-curtain-light/led-curtain-light-7.jpg' }
              ].map((color) => (
                <div key={color.name} className="flex flex-col">
                  <button 
                    className={`w-[80px] h-[80px] border ${color.name === selectedColor ? 'border-2 border-green-500' : 'border border-gray-600'} 
                      rounded-md bg-gray-800 flex items-center justify-center overflow-hidden relative`}
                    onClick={() => {
                      setSelectedColor(color.name);
                      setCurrentImage(color.image);
                    }}
                  >
                    <div className="w-full h-full flex items-center justify-center">
                      <img 
                        src={color.image}
                        alt={color.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    {color.name === selectedColor && (
                      <div className="absolute top-0 right-0 w-0 h-0 border-t-[20px] border-r-[20px] border-t-transparent border-r-green-500"></div>
                    )}
                  </button>
                  <div className="mt-2 text-center">
                    <div className="text-sm text-white font-medium">
                      {color.name === 'Warm (with hook)' ? (
                        <>
                          <div>Warm</div>
                          <div className="text-xs text-gray-400">(with hook)</div>
                        </>
                      ) : (
                        color.name
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* 选择长度 */}
          <div className="mb-6">
            <h3 className="text-lg font-medium mb-3">Length</h3>
            <div className="grid grid-cols-1 gap-3">
              {[
                { length: '3m x 3m', available: true },
                { length: '5m x 3m', available: false },
                { length: '10m x 5m', available: false }
              ].map(({ length, available }) => (
                <button 
                  key={length}
                  className={`border-2 ${length === selectedLength ? 'border-green-500' : 'border-gray-700'} 
                    rounded-md py-3 px-4 text-center transition-colors relative
                    ${!available ? 'opacity-50 cursor-not-allowed' : 'hover:border-green-500'}`}
                  onClick={() => available && setSelectedLength(length)}
                  disabled={!available}
                >
                  {length}
                  {!available && (
                    <span className="absolute top-1 right-1 text-xs bg-red-600 text-white px-1 rounded">
                      SOLD OUT
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
          
          {/* 数量 */}
          <div className="mb-8">
            <h3 className="text-lg font-medium mb-3">Quantity</h3>
            <div className="flex items-center">
              <button 
                className="bg-gray-800 px-4 py-2 rounded-l-md"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                -
              </button>
              <input 
                type="text" 
                value={quantity} 
                readOnly
                className="bg-gray-800 text-center w-16 py-2 border-x border-gray-700"
              />
              <button 
                className="bg-gray-800 px-4 py-2 rounded-r-md"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
          </div>
          
          {/* 购买按钮 */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <button 
              onClick={handleAddToCart}
              className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-md font-medium transition-colors"
            >
              Add to Cart
            </button>
            <button 
              onClick={handleBuyNow}
              className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium border border-gray-600 transition-colors"
            >
              Buy Now
            </button>
          </div>
          
          {/* 配送信息 */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex items-center mb-3">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2a1 1 0 00.9-.5l1.5-2A1 1 0 0015 7h-3V4a1 1 0 00-1-1H3zM14 7l-1.5 2H10V5h4v2z" />
              </svg>
              <span className="text-gray-300">Free Meet Up (Available at Sengkang & Orchard locations)</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              <span className="text-gray-300">Available Shipping</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* 产品详情选项卡 */}
      <div className="mt-16">
        <div className="border-b border-gray-700 mb-8">
          <div className="flex space-x-8">
            <button 
              onClick={() => setActiveTab('overview')}
              className={`pb-4 px-2 font-medium ${activeTab === 'overview' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Overview
            </button>
            <button 
              onClick={() => setActiveTab('specs')}
              className={`pb-4 px-2 font-medium ${activeTab === 'specs' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Specifications
            </button>
            <button 
              onClick={() => setActiveTab('reviews')}
              className={`pb-4 px-2 font-medium ${activeTab === 'reviews' ? 'text-white border-b-2 border-green-500' : 'text-gray-400'}`}
            >
              Reviews ({product.reviews})
            </button>
          </div>
        </div>
        
        {/* 选项卡内容 */}
        <div>
          {activeTab === 'overview' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Product Overview</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div>
                  <p className="text-gray-300 mb-6">
                    Transform any space with our stunning LED Curtain Lights! Perfect for both indoor and outdoor decoration, 
                    these waterproof LED lights create a magical atmosphere with 300 bright LEDs arranged in a beautiful curtain pattern.
                  </p>
                  <p className="text-gray-300 mb-6">
                    Featuring 8 different lighting modes including steady, flashing, and chasing effects, these lights are perfect 
                    for parties, weddings, holidays, or simply creating a cozy ambiance in your home. The IP44 waterproof rating 
                    ensures they can withstand outdoor conditions.
                  </p>
                  <p className="text-gray-300">
                    Easy to install with included clips and powered by USB or AC adapter, these LED curtain lights are the perfect 
                    way to add sparkle and magic to any occasion. Create unforgettable memories with beautiful, energy-efficient lighting!
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-4">Key Features</h3>
                  <ul className="space-y-4">
                    {product.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="w-6 h-6 mr-2 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <div>
                          <span className="font-medium">{feature}</span>
                          <p className="text-gray-400 text-sm mt-1">
                            {feature === "300 LED Lights" && "300 high-brightness LED beads providing bright and uniform lighting effects"}
                            {feature === "Waterproof IP44" && "IP44 waterproof rating, suitable for both indoor and outdoor use, durable and long-lasting"}
                            {feature === "8 Light Modes" && "8 different lighting modes to meet various decoration needs"}
                            {feature === "Easy Installation" && "Simple and easy installation with included clips for quick decoration setup"}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'specs' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Technical Specifications</h2>
              <div className="bg-gray-800 rounded-lg p-6">
                <table className="w-full">
                  <tbody>
                    {Object.entries(product.specs).map(([key, value], index) => (
                      <tr key={index} className={index !== 0 ? "border-t border-gray-700" : ""}>
                        <td className="py-4 pr-4 font-medium w-1/3">{key}</td>
                        <td className="py-4 text-gray-300">{value}</td>
                      </tr>
                    ))}
                    <tr className="border-t border-gray-700">
                      <td className="py-4 pr-4 font-medium">Dimensions</td>
                      <td className="py-4 text-gray-300">3m x 3m (expandable)</td>
                    </tr>
                    <tr className="border-t border-gray-700">
                      <td className="py-4 pr-4 font-medium">Weight</td>
                      <td className="py-4 text-gray-300">200g</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          
          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Customer Reviews</h2>
              <div className="flex items-center mb-8">
                <div className="mr-4">
                  <div className="text-5xl font-bold">{product.rating}</div>
                  <div className="flex text-yellow-400 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className={i < Math.floor(product.rating) ? "text-yellow-400" : "text-gray-600"}>★</span>
                    ))}
                  </div>
                  <div className="text-sm text-gray-400 mt-1">Based on {product.reviews} reviews</div>
                </div>
                <div className="flex-1 ml-6">
                  {[5, 4, 3, 2, 1].map((star) => (
                    <div key={star} className="flex items-center mb-2">
                      <div className="w-12 text-sm text-gray-400">{star} stars</div>
                      <div className="w-full bg-gray-700 rounded-full h-2 mx-2">
                        <div 
                          className="bg-yellow-400 h-2 rounded-full" 
                          style={{ 
                            width: `${star === 5 ? 85 : star === 4 ? 12 : star === 3 ? 2 : star === 2 ? 1 : 0}%` 
                          }}
                        ></div>
                      </div>
                      <div className="w-12 text-sm text-right text-gray-400">
                        {star === 5 ? '85%' : star === 4 ? '12%' : star === 3 ? '2%' : star === 2 ? '1%' : '0%'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* 示例评论 */}
              <div className="space-y-6">
                {[
                  { name: "Emma L.", rating: 5, date: "2 days ago", comment: "Absolutely stunning LED curtain lights! Used them for our wedding reception and they created the most magical atmosphere. The 8 different modes are incredible - everyone was asking where we got them. Installation was super easy with the included clips. Worth every penny!" },
                  { name: "Michael R.", rating: 5, date: "1 week ago", comment: "These lights are absolutely amazing! Used them for my daughter's birthday party and they were the star of the show. The 300 LEDs provide perfect brightness, and the IP44 waterproof rating worked great when we moved the party outside. The 8 lighting modes kept everyone entertained all night. Highly recommend!" },
                  { name: "Sarah K.", rating: 5, date: "2 weeks ago", comment: "Best LED lights I've ever purchased! The quality is outstanding and they look absolutely beautiful in our bedroom. The warm white option creates such a cozy atmosphere. Installation took less than 10 minutes and they've been working perfectly for months. The USB power is so convenient. 5 stars!" },
                  { name: "David M.", rating: 5, date: "3 weeks ago", comment: "Incredible value for money! These LED curtain lights transformed our living room into a magical space. The 8 different modes are fantastic - my kids love the chasing effects. The build quality is excellent and they're surprisingly bright. The USB power option is perfect for our setup. Would definitely buy again!" },
                  { name: "Lisa W.", rating: 5, date: "1 month ago", comment: "Perfect for any occasion! Used these for Christmas decorations and they looked absolutely gorgeous. The 300 LEDs provide amazing coverage and the different modes create such beautiful effects. Easy to install and the waterproof feature gives me peace of mind. Excellent product!" }
                ].map((review, index) => (
                  <div key={index} className="border-b border-gray-700 pb-6">
                    <div className="flex justify-between mb-2">
                      <span className="font-medium">{review.name}</span>
                      <span className="text-gray-400 text-sm">{review.date}</span>
                    </div>
                    <div className="flex text-yellow-400 mb-2">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className={i < review.rating ? "text-yellow-400" : "text-gray-600"}>★</span>
                      ))}
                    </div>
                    <p className="text-gray-300">{review.comment}</p>
                  </div>
                ))}
              </div>
              
              {/* 查看更多评论按钮 */}
              <div className="mt-8 text-center">
                <button className="bg-gray-800 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium">
                  Load More Reviews
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {/* 相关产品 */}
      <div className="mt-20">
        <h2 className="text-2xl font-bold mb-8">You May Also Like</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {relatedProducts.map(product => (
            <div key={product.id} className="bg-gray-800 rounded-lg overflow-hidden">
              <img src={product.image} alt={product.name} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="font-medium mb-2">{product.name}</h3>
                <div className="flex justify-between items-center">
                  <span className="font-bold">${product.price}</span>
                  <button className="bg-green-600 hover:bg-green-700 text-white py-1 px-3 rounded-md text-sm">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* 相关产品 */}
      <RelatedProducts 
        currentProductId={22} 
        currentCategory="lighting" 
        limit={4} 
      />
    </div>
  );
};

export default LEDCurtainLight;
